import type { JSX } from 'react'

import { TopNumber7SC } from './TopNumbers.styled'

export const Top7 = (): JSX.Element => (
  <TopNumber7SC
    width='128'
    height='188'
    viewBox='0 0 128 188'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M128 0V18.0977L49.9578 188H20.2532L17.2827 186.92L94.7848 26.2011H0V0H128Z'
      fill='url(#paint0_linear_5096_100032)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100032'
        x1='-22.6835'
        y1='-0.236335'
        x2='163.974'
        y2='167.115'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber7SC>
)
